// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"169":"9a42df1c","195":"14c2d608","228":"cc85ab03","335":"1498605a","336":"9a7ae4ec","394":"c039f2f1","621":"b8d9e7d6","692":"5b2cc9aa","725":"b7f909a4","760":"87999731","789":"67055e64"}[chunkId] + ".js";
};